/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Pxk_Edit_TitleInputs */

const vi_pll_pxk_edit_title = /** @type {(inputs: Pll_Pxk_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phiếu xuất thành phẩm`)
};

/**

* @param {Pll_Pxk_Edit_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_pxk_edit_title = /** @type {((inputs?: Pll_Pxk_Edit_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Pxk_Edit_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_pxk_edit_title(inputs)
});